import { useState } from 'react'
import { Dialog } from 'antd-mobile'
import { checkThreeFactor, detectFaceidAuth } from '../../api/orderService'

interface ThreeFactorValues {
  name: string
  idCard: string
  phone: string
  smsCode?: string
  employeeCode?: string
  [key: string]: any
}

interface UseThreeFactorVerificationOptions {
  linkId: string
  employeeId: string
  onSuccess: () => void
  onError?: () => void
}

export function useThreeFactorVerification({
  linkId,
  employeeId,
  onSuccess,
  onError,
}: UseThreeFactorVerificationOptions) {
  const [verifying, setVerifying] = useState(false)

  const verify = async (values: ThreeFactorValues): Promise<boolean> => {
    setVerifying(true)
    try {
      const checkRes = await checkThreeFactor(values)

      if (checkRes !== '1') {
        const handleFaceVerification = () => {
          detectFaceidAuth({
            ...values,
            smsCode: values.smsCode || '',
            linkId: linkId,
            employeeId: employeeId,
            employeeCode: values.employeeCode || '',
            ticket: values.ticket || '',
            randstr: values.randstr || '',
          }).then((res) => {
            if (res?.url) {
              window.location.href = res.url
            }
          })
        }
        Dialog.show({
          title: '信息核验',
          content: <div style={{ padding: '8px 0' }}>检测到姓名，身份证号和手机号不一致，请选择以下方式继续。</div>,
          closeOnAction: true,
          actions: [
            [
              {
                key: 'edit',
                text: '修改基本信息',
                style: {
                  color: '#666666',
                  background: '#f5f5f5',
                },
              },
              {
                key: 'face',
                text: '人脸识别核验',
                style: {
                  color: '#ffffff',
                  background: '#4086FF',
                },
                onClick: handleFaceVerification,
              },
            ],
          ],
        })
        onError?.()
        return false
      }

      onSuccess()
      return true
    } catch (error) {
      console.error('Three factor verification failed:', error)
      onError?.()
      return false
    } finally {
      setVerifying(false)
    }
  }

  return {
    verify,
    verifying,
  }
}
